module.exports = __webpack_public_path__ + "static/media/my_image.671f5dee.jpg";